<template>
  <div class="login">
    <div class="login-before"></div>
    <div class="login-box">
      <div class="top"></div>
      <div class="top-copy">
        <div class="left">
          <div class="img-box">
            <img src="../../assets/logo1.png" alt />
          </div>
          <div class="icon"></div>
          <div class="tit">厂家自助服务</div>
        </div>
        <div class="right" id="time">{{ formateTimeStamp(date) }}</div>
      </div>
      <div class="center">
        <div class="title">欢迎使用厂家自助服务系统</div>
        <div class="sys">
          <div class="sys1" @click="goLogin(1,'排号LED')">
            <div class="msg1">排号LED</div>
            <div class="msg2">显示</div>
            <div class="icon-img">
              <img src="../../assets/sys1.png" alt srcset />
            </div>
          </div>
          <div class="sys2" @click="goLogin(2,'打印样品')">
            <div class="msg1">打印样品</div>
            <div class="msg2">条码</div>
            <img src="../../assets/sys2.png" alt srcset />
          </div>
          <!-- <div class="sys3">
            <div class="msg1">登记样品</div>
            <div class="msg2">出入</div>
            <img src="../../assets/sys3.png" alt="" srcset="">
          </div>-->
          <div class="sys5" @click="goLogin(4,'打印排号')">
            <div class="msg1">打印排号</div>
            <div class="msg2">自动</div>
            <img src="../../assets/sys2.png" alt srcset />
          </div>
          <div class="sys4" @click="goLogin(5,'厂商卡号验证')">
            <div class="msg1">厂商卡号</div>
            <div class="msg2">验证</div>
            <img src="../../assets/sys2.png" alt srcset />
          </div>
          <div class="sys3" @click="goLogin(3,'打印择样')">
            <div class="msg1">打印择样</div>
            <div class="msg2">记录</div>
            <img src="../../assets/sys2.png" alt srcset />
          </div>
          <div class="sys6" @click="goLogin(6,'样品进出登记')">
            <div class="msg1">样品进出登记</div>
            <!-- <div class="msg2">记录</div> -->
            <img src="../../assets/sys2.png" alt srcset />
          </div>
        </div>
      </div>
      <div class="footer">
        <div class="left">版权所有@宏升软件</div>
        <div class="right"></div>
      </div>
    </div>
    <el-dialog
      center
      width="25%"
      :title="loginTitle+' 登录'"
      :modal-append-to-body="false"
      :close-on-click-modal="false"
      :visible.sync="visible"
      :before-close="handleClose"
    >
      <el-tabs v-model="activeName">
        <el-tab-pane label="二维码登录" name="qrCode">
          <div class="login-qr">
            <div class="image">
              <img :src="qrData.qrCode" />
              <div v-if="timeNum === 60" @click="getLoginQRCode">
                <div class="bg"></div>\
                <i class="reload el-icon-refresh-right"></i>
              </div>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="手机号登录" name="mobile">
          <div class="mobile-box">
            <el-form ref="form" :model="loginForm" :rules="rules" label-width="65px">
              <el-form-item label="手机号" prop="mobile">
                <el-input v-model="loginForm.mobile" placeholder="请输入手机号" maxlength="11"></el-input>
              </el-form-item>
              <el-form-item label="验证码" prop="verificationCode">
                <el-row>
                  <el-col :span="14">
                    <el-input v-model="loginForm.verificationCode" placeholder="请输入验证码" maxlength="6"></el-input>
                  </el-col>
                  <el-col :offset="1" :span="9">
                    <el-button
                      :disabled="codeStatus"
                      type="primary"
                      style="width: 100%;"
                      @click="sendLoginCode"
                    >{{ codeStatus ? countDown + 's后重新获取': '发送验证码' }}</el-button>
                  </el-col>
                </el-row>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" class="btn-login" @click="loginSubmit">登录</el-button>
              </el-form-item>
            </el-form>
          </div>
        </el-tab-pane>
      </el-tabs>
    </el-dialog>
  </div>
</template>

<script>
import { getLoginQRCode, weChatLoginCheck, qrCodeLogin, authGetSmsCode, mobileLogin } from '@/api/login'
import { mapActions } from 'vuex'
export default {
  data() {
    return {
      visible: false,
      times: '',
      mobileTimes: null,
      timeNum: 0,
      date: new Date().getTime(),
      qrData: {},
      loginTitle: '',
      activeName: 'qrCode',
      codeStatus: false,
      countDown: 0,
      loginForm: {
        mobile: '',
        verificationCode: ''
      },
      rules: {
        mobile: [
          { required: true, message: '请输入手机号码', trigger: 'blur' },
          { min: 11, max: 11, message: '请输入正确的手机号码', trigger: 'blur' }
        ],
        verificationCode: [
          { required: true, message: '请输入验证码', trigger: 'blur' }
        ]
      }
    }
  },
  created() {
    this.loadTime()
  },
  methods: {
    ...mapActions('tenant', ['set_tenantInfo']),
    handleClose(done) {
      this.visible = false
      clearInterval(this.times)
      clearInterval(this.mobileTimes)
      this.countDown = 0
      this.codeStatus = false
    },
    loadTime() {
      var _this = this
      setInterval(() => {
        _this.date += 1000
      }, 1000)
    },
    // 转换时间戳
    formateTimeStamp(time) {
      var date = new Date(time)
      var year = date.getFullYear()
      var month =
        date.getMonth() + 1 < 10
          ? '0' + (date.getMonth() + 1)
          : date.getMonth() + 1
      var day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
      var hour = date.getHours() < 10 ? '0' + date.getHours() : date.getHours()
      var minute =
        date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
      var second =
        date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
      var week = ['日', '一', '二', '三', '四', '五', '六'][date.getDay()]
      return (
        year +
        '年' +
        month +
        '月' +
        day +
        '日 ' +
        ' 星期' +
        week +
        ' ' +
        hour +
        ':' +
        minute +
        ':' +
        second
      )
    },

    goLogin(status, title) {
      localStorage.setItem('status', status)
      this.visible = true
      this.loginTitle = title
      this.getLoginQRCode()
      this.mobileTimes = null
    },

    // 获取登录二维码
    getLoginQRCode() {
      this.timeNum = 0
      getLoginQRCode().then(res => {
        if (res.success) {
          this.qrData = res.data

          this.times = setInterval(() => {
            this.timeNum += 1
            let countRemainder = this.timeNum % 1
            if (countRemainder == 0) {
              this.weChatLoginCheck()
            }
            if (this.qrData.expireSeconds === this.timeNum) {
              clearInterval(this.times)
            }
          }, 1000)
        }
      })
    },
    // 轮询是否登录
    weChatLoginCheck() {
      weChatLoginCheck({ sceneId: this.qrData.sceneId }).then(res => {
        if (res.data.isLogin === 1) {
          clearInterval(this.times)
          clearInterval(this.mobileTimes)
          this.qrCodeLogin(res.data.openId)
        }
      })
    },
    //二维码登录
    qrCodeLogin(openId) {
      qrCodeLogin({ openId: openId })
        .then(res => {
          if (res.success) {
            this.set_tenantInfo(res.data)
            this.$message.success('登录成功')
            this.$router.push('/home')
          } else {
            this.$message.error('登录失败' + res.message)
            this.visible = false
          }
        })
        .catch(err => {
          this.$message.error('登录失败' + err)
          this.visible = false
        })
    },
    // 发送验证码
    sendLoginCode() {
      const mobileReg = /^1[3456789]\d{9}$/
      if (this.loginForm.mobile === '' || !mobileReg.test(this.loginForm.mobile)) {
        this.$message.warning('请输入正确的手机号')
        return
      }
      authGetSmsCode({ mobile: this.loginForm.mobile }).then(res => {
        if (res.success) {
          const TIME_COUNT = 60
          if (!this.mobileTimes) {
            this.countDown = TIME_COUNT
            this.codeStatus = true
            this.mobileTimes = setInterval(() => {
              if (this.countDown > 0 && this.countDown <= TIME_COUNT) {
                this.countDown--
              } else {
                this.codeStatus = false
                clearInterval(this.mobileTimes)
                this.mobileTimes = null
              }
            }, 1000)
          }
        } else {
          this.$message.error(res.message)
        }
      })
    },
    loginSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          mobileLogin(this.loginForm).then(res => {
            if (res.success) {
              this.set_tenantInfo(res.data)
              this.$message.success('登录成功')
              clearInterval(this.times)
              clearInterval(this.mobileTimes)
              this.$router.push('/home')
            } else {
              this.$message.error('登录失败' + res.message)
              this.visible = false
            }
          })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.login {
  height: 100vh;
  background-color: #eee;
  padding: 0;
  margin: 0;
  background-image: linear-gradient(to right, #0457ff, #4cb1f6);
  position: relative;
  z-index: 0;
  overflow: hidden;
  color: #fff;
  font-size: 0.2rem;
  .login-before {
    content: '';
    position: absolute;
    left: -5rem;
    top: -6.16rem;
    width: 100vw;
    height: 100%;
    background-image: linear-gradient(to right, #0457ff, #4baff6);
    transform: rotate(330deg);
    overflow: hidden;
  }
}

.login-box {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 100;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  // justify-content: space-between;
  .top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    min-height: 1.2rem;
    opacity: 0.35;
    background: #0457ff;
    border: 0.01rem solid #27d4d2;
    padding: 0 0.66rem;
    box-sizing: border-box;
  }
  .top-copy {
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    min-height: 1.2rem;
    padding: 0 0.66rem;
    box-sizing: border-box;
    .left {
      display: flex;
      align-items: center;
      height: 0.58rem;

      .img-box {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 2.4rem;
        height: 0.58rem;
        img {
          max-width: 2.4rem;
          max-height: 0.58rem;
        }
      }
      .icon {
        width: 0.02rem;
        height: 80%;
        background-color: #fff;
        margin: 0 0.4rem 0 0.2rem;
      }

      .tit {
        font-size: 0.42rem;
        font-family: MicrosoftYaHei;
      }
    }
  }

  .center {
    .title {
      font-size: 0.72rem;
      margin: 0.86rem 0 0 0;
      text-align: center;
    }
    .sys {
      display: flex;
      margin: 0.6rem 0 0;
      & > div {
        position: relative;
        width: 2.64rem;
        height: 3.92rem;
        margin: 0 0.25rem;
        border-radius: 0.2rem;
        padding: 0.42rem 0.44rem;
        box-sizing: border-box;
        font-size: 0.42rem;
        font-family: MicrosoftYaHei;

        img {
          width: 1.4rem;
          position: absolute;
          right: 0.3rem;
          bottom: 0.3rem;
        }

        &:hover {
          box-shadow: 0 0 0.08rem 0.02rem #eee;
          cursor: pointer;
        }
      }

      .sys1 {
        background-image: linear-gradient(310deg, #6086f8, #71a1fc, #76acfc);
      }
      .sys2 {
        background-image: linear-gradient(310deg, #fc9467, #fda883, #f8af92);
      }
      .sys3 {
        background-image: linear-gradient(310deg, #e9b25f, #e8b872, #edc080);
      }
      .sys4 {
        background-image: linear-gradient(310deg, #f06875, #f9828f, #fb8a97);
      }
      .sys5 {
        background-image: linear-gradient(310deg, #ff9736, #f3b671, #fbd78a);
      }

      .sys6 {
        background-image: linear-gradient(310deg, #fc9467, #fda883, #f8af92);
      }
    }
  }

  .footer {
    width: 100%;
    display: flex;
    padding: 0.2rem 1rem;
    justify-content: space-between;
    box-sizing: border-box;
    margin: 1.3rem 0;
  }
}

.mobile-box {
  padding: 20px 0 10px;

  .btn-login {
    margin-top: 10px;
    width: 100%;
  }
}

.login-qr {
  height: 3.6rem;
  display: flex;
  justify-content: center;

  .image {
    position: relative;
    width: 3.2rem;
    height: 3.2rem;
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      max-width: 3.2rem;
      max-height: 3.2rem;
    }

    .bg {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: #222;
      opacity: 0.6;
    }
    .reload {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      font-size: 0.7rem;
      color: #999;
      text-align: center;
      background-color: #aaa;
      border-radius: 50%;
      padding: 0.3rem;
      cursor: pointer;
    }
  }
}
</style>